import Vue from 'vue';
import VueCookie from 'vue-cookies';
import {faqService} from "../network/services/faq.service";
import {hasIntersection} from "../helpers/array.helper";

const COOKIE_NAME = 'mihPublicInstance';
Vue.use(VueCookie);

const USE_UNIQUE_ARTICLE_IN_SEARCH = true;

function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

function createFilter (getters, rootGetters) {
    return ({v_suites, v_extras, v_booking, v_not_booking}) => {
        if ((!rootGetters.isAuth || (rootGetters.isAuth && !getters.hasBooking)) && v_not_booking) return true;
        if (rootGetters.isAuth && getters.hasBooking && v_booking
            && hasIntersection(getters.currentBookingRooms, v_suites)
            // && (getters.currentExtras.length === 0 || hasIntersection(getters.currentExtras, v_extras))
        ) return true;
        return false;
    };
}

export default {
    namespaced: true,
    state: {
        uuid: (Vue.$cookies.get(COOKIE_NAME) || {uuid: uuidv4()}).uuid,
        loading: false,
        loadingAuth: false,
        loadingSearch: false,
        faqCategories: [],
        rooms: [],
        extras: [],
        searchResults: null
    },
    getters: {
        loading: s => s.loading || s.loadingAuth,
        hasBooking: s => s.rooms.length > 0,
        currentBookingRooms: s => s.rooms,
        currentExtras: s => s.extras,
        categories: (s, getters, rootState, rootGetters) => {
            const result = [];

            const filterProcess = createFilter(getters, rootGetters);

            for (const category of s.faqCategories) {
                const tmp = {...category};
                tmp.is_visible = filterProcess(tmp);
                if (!filterProcess(category)) continue;
                if (tmp.faq_category_id !== null) continue;
                tmp.faq_categories_articles = tmp.faq_categories_articles.filter(filterProcess);
                if (tmp.faq_categories_articles.length === 0) continue;
                result.push(tmp);
            }
            return result;
        },
        hasSearchResult: s => s.searchResults !== null,
        searchResultCount: (s, getters) => getters.hasSearchResult ?
            getters.searchResults.articles.length + getters.searchResults.categories.length
            + getters.searchResults.keywords.reduce((p, n) => (p + n.articles.length), 0) : 0,
        searchTerm: s => s.searchResults ? s.searchResults.request : null,
        searchResults: (s, getters, rootState, rootGetters) => {
            const filterProcess = createFilter(getters, rootGetters);
            const result = {
                articles: [],
                categories: [],
                keywords: []
            };
            if (s.searchResults.matching.faq.keywords && !Array.isArray(s.searchResults.matching.faq.keywords)) {
                s.searchResults.matching.faq.keywords = [s.searchResults.matching.faq.keywords];
            }
            if (!getters.hasSearchResult) return result;
            const usedArticles = [];
            if (s.searchResults.matching.faq.articles) result.articles.push(...s.searchResults.matching.faq.articles.filter(filterProcess));
            usedArticles.push(...result.articles.map(a => a.id));
            if (s.searchResults.matching.faq.categories) result.categories.push(...s.searchResults.matching.faq.categories.filter(filterProcess));
            if (s.searchResults.matching.faq.keywords) result.keywords.push(...s.searchResults.matching.faq.keywords.map(keyword => {
                if (!keyword.articles) keyword.articles = [];
                keyword.articles = keyword.articles.filter(a => usedArticles.indexOf(a.id) === -1).filter(filterProcess);
                usedArticles.push(...keyword.articles.map(a => a.id));
                return keyword;
            }).filter(keyword => keyword.articles.length > 0));
            return result;
        }
    },
    mutations: {
        PERSIST(state) {
            Vue.$cookies.set(COOKIE_NAME, {uuid: state.uuid}, Infinity);
        },
        SET_LOADING (state, payload) {
            state.loading = !!payload;
        },
        SET_AUTH_LOADING (state, payload) {
            state.loadingAuth = !!payload;
        },
        SET_SEARCH_LOADING (state, payload) {
            state.loadingSearch = !!payload;
        },
        SET_CATEGORIES(state, payload) {
            state.faqCategories = payload;
        },
        SET_EXTRAS (state, payload) {
            state.extras = payload ? payload : [];
        },
        SET_ROOMS (state, payload) {
            state.rooms = payload ? payload : [];
        },
        SET_SEARCH_RESULT (state, payload) {
            state.searchResults = payload;
        }
    },
    actions: {
        async fetch (context, {lang}) {
            context.commit('PERSIST');
            context.commit('SET_LOADING', true);
            const token = context.state.uuid;
            const response = await faqService.fetchCategories({lang, token});
            context.commit('SET_CATEGORIES', response.get('result'));
            context.commit('SET_LOADING', false);
        },
        async fetchAuthBookings (context) {
            context.commit('SET_EXTRAS', [])
            context.commit('SET_ROOMS', [])
            if (!context.rootGetters.isAuth) return;
            const access = context.rootState.client.tokens.accessToken;
            context.commit('SET_AUTH_LOADING', true);
            const response = await faqService.fetchAuthBookings(access);
            context.commit('SET_EXTRAS', response.get('Auth.incoming_bookings.extras', []))
            context.commit('SET_ROOMS', response.get('Auth.incoming_bookings.rooms', []))
            context.commit('SET_AUTH_LOADING', false);
        },
        async search (context, {search, lang}) {
            context.commit('SET_SEARCH_RESULT', null);
            context.commit('SET_SEARCH_LOADING', true);
            const token = context.state.uuid;
            const response = await faqService.search(search, lang, token);
            context.commit('SET_SEARCH_RESULT', response.get('result'));
            context.commit('SET_SEARCH_LOADING', false);
        }
    }
}



// WEBPACK FOOTER //
// ./src/stores/faq.store.js